import axios from "./axios";

const CLIENT_ID = "b6ed9ba1a9e54dae9750845a83b9279e";
const CLIENT_SECRET = "07d81f9457a6916e9018fc151bc06d22";

export const login = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/oauth2/token",
        data: {"client_id": CLIENT_ID,
                "client_secret": CLIENT_SECRET,
                "grant_type": "password",
                ...dataObject
            }
    })
}

export const getUser = (dataObject={}) => {
    return axios({
        method: "get",
        url: "/v3/user/list",
        params: {"clientId": CLIENT_ID,
                "clientSecret": CLIENT_SECRET,
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const addUser = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/user/register",
        data: {"clientId": CLIENT_ID,
                "clientSecret": CLIENT_SECRET,
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const delUser = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/user/delete",
        data: {"clientId": CLIENT_ID,
                "clientSecret": CLIENT_SECRET,
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const resetPass = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/user/resetPassword",
        data: {"clientId": CLIENT_ID,
                "clientSecret": CLIENT_SECRET,
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const getLock = (dataObject={}) => {
    return axios({
        method: "get",
        url: "/v3/key/list",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

// export const getLock = (dataObject={}) => {
//     return axios({
//         method: "get",
//         url: "/v3/lock/list",
//         params: {"clientId": CLIENT_ID,
//                 "accessToken": window.localStorage.getItem("access_token"),
//                 "date": Date.now(),
//                 ...dataObject
//             }
//     })
// }

export const viewLock = (dataObject={}) => {
    return axios({
        method: "get",
        url: "/v3/lockRecord/list",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const viewYaoshi = (dataObject={}) => {
    return axios({
        method: "get",
        url: "/v3/lock/listKey",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const setGroup = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/lock/setGroup",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const getGroup = (dataObject={}) => {
    return axios({
        method: "get",
        url: "/v3/group/list",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const delGroup = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/group/delete",
        params: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const addGroup = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/group/add",
        data: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const editGroup = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/v3/group/update",
        data: {"clientId": CLIENT_ID,
                "accessToken": window.localStorage.getItem("access_token"),
                "date": Date.now(),
                ...dataObject
            }
    })
}

export const com = (dataObject={}) => {
    return axios({
        method: "post",
        url: "/com",
        data: dataObject
    })
}

// export const get_room_id = (dataObject={}) => {
//     return axios({
//         method: "get",
//         url: "resident/organization/room/getid",
//         params: dataObject
//     })
// }



